module.exports = {
	"name": "videojs5",
	"type": "adapter",
	"tech": "js",
	"author": "Jordi Aguilar",
	"version": "6.0.1",
	"built": "2017-07-11",
	"repo": "https://bitbucket.org/npaw/videojs5-adapter-js.git",
	"libVersion": "6.0.4",
	"features": {
		"buffer": "monitor",
		"seek": "native",
		"getters": [
			"getPlayhead",
			"getDuration",
			"getBitrate",
			"getRendition",
			"getResource"
		]
	},
	"ads": [
		{
			"buffer": "monitor",
			"seek": "monitor",
			"getters": [],
			"filename": "generic.js"
		},
		{
			"buffer": "monitor",
			"seek": "monitor",
			"getters": [
				"getPlayhead",
				"getDuration",
				"getTitle",
				"getResource"
			],
			"filename": "ima.js"
		},
		{
			"buffer": "monitor",
			"seek": "monitor",
			"getters": [
				"getPlayhead",
				"getDuration",
				"getResource"
			],
			"filename": "onceux.js"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 9
// module chunks = 0